import {
    GET_ALL_COURSES,
    GET_COURSE,
    CAC_LOADING,
    ADD_COURSE
  } from "../actions/ExtracurricularCoursesAdminCursesAction";
  
  
  const initialState = {
    courseslist: [],
    course: [],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CAC_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_COURSES: {
            return{
                ...state,
                courseslist : [...action.data],
                course:[],
                loading: false,
                add : false,
            }
        }
        case GET_COURSE: {
          return{
              ...state,
              course : [...action.data],
              loading: false
          }
        }
        case ADD_COURSE: {
          return {
            ...state,
            course:[],
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  